module.exports = "/images/close_search.svg";